import { createRoute } from '@tanstack/react-router';

import { AdminBaseRouteLayout } from '$/routes/Admin/AdminBaseRouteLayout';

export const AdminKeyUserManagementRoute = createRoute({
  getParentRoute: () => AdminBaseRouteLayout,
  path: '/admin/key-user-management',
}).lazy(() =>
  import('./AdminKeyUserManagementRoute.lazy').then((d) => d.Route),
);
